var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageCoachIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000007040"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4585",
    y: 1,
    width: 16,
    height: 16,
    rx: 3,
    fill: "#68A14B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1630",
    d: "M4.80078 6.2V1H11.2008V6.2C11.2008 7.02405 10.26 7.49443 9.60078 7L8.60078 6.25C8.24523 5.98333 7.75634 5.98333 7.40078 6.25L6.40078 7C5.74155 7.49443 4.80078 7.02404 4.80078 6.2Z",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageCoachIcon);
export default __webpack_public_path__ + "static/media/manage-coach-icon.a0eb3064e59859e236f820cf2f906e6c.svg";
export { ForwardRef as ReactComponent };